import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocalAuth } from "@/components/auth/LocalAuth";

export function LogoutButton() {
  const { user, logout } = useLocalAuth();
  const navigate = useNavigate();
  if (!user) return null;
  return (
    <Button variant="outline" size="sm" className="rounded-full gap-1.5" data-testid="topbar-logout-btn"
      onClick={() => { logout(); navigate("/"); }}>
      <LogOut className="h-4 w-4" /><span className="hidden sm:inline">Çıkış</span>
    </Button>
  );
}
